import { TemplateKey } from "PFApp/constants/templates";
import { Accordion, AccordionState } from "PFComponents/accordion";
import { Button } from "PFComponents/button";
import { useSubtemplates } from "PFCore/hooks/queries/subtemplates/use_subtemplates";
import { Subtemplate } from "PFCore/types";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type SubtemplateAccordionProps = {
  subtemplate: Subtemplate | null;
  children: ReactNode;
  addRole: (subtemplateKey?: string) => void;
  onStateChange?: (state: AccordionState) => void;
};

export const SubtemplateAccordion = ({
  subtemplate,
  addRole,
  children,
  onStateChange
}: SubtemplateAccordionProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "engagementBlueprint" });
  const { data: hasSubtemplates } = useSubtemplates<boolean>(
    { templateKey: TemplateKey.Role },
    { select: (data) => data.length > 0 }
  );

  if (!subtemplate && !hasSubtemplates) {
    return <div>{children}</div>;
  }

  return (
    <Accordion
      header={subtemplate?.subtemplate_title ?? t("noSubtemplate")}
      headerVariant="bodyBold"
      headerFullWidth={true}
      animated={false}
      keepMounted
      iconSet="chevron"
      onStateChange={onStateChange}
      actions={
        subtemplate && (
          <Button
            kind="secondary"
            icon="add"
            title={t("addRoleToSubtemplate", {
              subtemplate: subtemplate.subtemplate_title
            })}
            onClick={() => addRole(subtemplate.subtemplate_key)}
            small
          />
        )
      }
    >
      {children}
    </Accordion>
  );
};
